/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import { getHeroSection, updateHeroSection } from "actions/heroSections";
import { clearHeroSection } from "features/heroSectionsSlice";
import { MediaField } from "components/AboutUsContentForm/MediaField";
import { ComponentHeader } from "components";
import { ADMIN_TEXTS } from "constants/adminTexts";
import { FILE_TYPE } from "constants/fileTypes";
import "./HeroSection.scss";
import { BrandButton } from "components/brand";

const imageBase = process.env.REACT_APP_API_IMAGE_URL;

export const HeroSection = () => {
  const dispatch = useDispatch();
  const { heroSection, loading, updateLoading } = useSelector(
    (state) => state.heroSections,
  );

  const [mediaFile, setMediaFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isVideo, setIsVideo] = useState(false);
  const [mediaError, setMediaError] = useState(null);

  useEffect(() => {
    dispatch(getHeroSection());
    return () => {
      dispatch(clearHeroSection());
    };
  }, []);

  useEffect(() => {
    if (heroSection?.media) {
      setPreviewUrl(`${imageBase}${heroSection.media.path}`);
      setIsVideo(heroSection.media.type === FILE_TYPE.VIDEO);
      setMediaFile(null);
    }
  }, [heroSection]);

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {
      if (!previewUrl) {
        setMediaError(ADMIN_TEXTS.about.mediaRequired);
        return;
      }
      dispatch(updateHeroSection({ mediaFile }));
    },
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setMediaFile(file);
    setIsVideo(file.type.startsWith("video"));
    setPreviewUrl(URL.createObjectURL(file));
    setMediaError(null);
  };

  const handleRemove = () => {
    setMediaFile(null);
    setPreviewUrl(
      heroSection?.media ? `${imageBase}${heroSection.media.path}` : null,
    );
    setIsVideo(heroSection?.media?.type === FILE_TYPE.VIDEO || false);
  };

  if (loading) {
    return (
      <Box className="hero-section-page">
        <Box className="loading-container">
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  return (
    <Box className="hero-section-page">
      <ComponentHeader title={ADMIN_TEXTS.heroSection.pageTitle} />
      <Card>
        <CardContent>
          <form onSubmit={formik.handleSubmit} className="hero-section-form">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MediaField
                  label={ADMIN_TEXTS.common.media}
                  file={mediaFile}
                  previewUrl={previewUrl}
                  isVideo={isVideo}
                  error={mediaError}
                  onFileChange={handleFileChange}
                  onRemove={handleRemove}
                />
              </Grid>

              <Grid item xs={12}>
                <Box className="form-footer">
                  <BrandButton
                    type="submit"
                    variant="primary"
                    disabled={updateLoading}
                    startIcon={
                      updateLoading ? <CircularProgress size={18} /> : <Save />
                    }
                  >
                    {updateLoading
                      ? ADMIN_TEXTS.actions.saving
                      : ADMIN_TEXTS.common.save}
                  </BrandButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};
